<template>
    <div component="ClientProjects" v-if="getClient">
        <div class="filter">
            <v-text-field class="search" v-model="search" label="Search" hide-details clearable />
            <v-select class="status" label="Status" :items="projectStatusItems" v-model="projectStatus" clearable />
        </div>
        <v-data-table
            ref="table"
            :headers="headers"
            :items="projects"
            :loading="loading"
            :search="search"
            :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
            :page.sync="page"
            fixed-header
            loading-text="Loading... Please wait"
            class="table"
        >
            <template v-slot:body="{ items }">
                <tbody>
                    <tr
                        v-for="(item, index) in items"
                        :key="index"
                        @click="openProject(item.id)"
                        :class="{ selected: getSelectedProject === item.id }"
                        :row="index"
                    >
                        <td class="id">
                            {{ item.index }}
                        </td>
                        <td class="name">
                            {{ item.nazov }}
                        </td>
                        <td class="date">
                            {{ item.zaciatok }}
                        </td>
                        <td class="status">
                            <v-chip :class="getProjectStatusCSS(item.status)" outlined pill small>
                                {{ item.status }}
                            </v-chip>
                        </td>
                        <td class="action">
                            <btn
                                v-if="item.status === 'IN PROGRESS'"
                                :icon="'close'"
                                color="ghost"
                                size="icon"
                                @click.stop="deletionIndex = index"
                            />
                            <div class="warning" :class="{ show: deletionIndex === index }">
                                <div class="label">Delete this project?</div>
                                <btn
                                    :icon="'close'"
                                    color="ghost"
                                    for-background="dark"
                                    size="icon"
                                    @click.stop="deletionIndex = null"
                                />
                                <btn
                                    :icon="'check'"
                                    color="ghost"
                                    for-background="dark"
                                    size="icon"
                                    @click.stop="deleteItem(item)"
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'ClientProjects',

    props: {
        loading: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            fatalError: false,
            showProject: false,
            search: '',
            projectStatus: null,
            projectStatusItems: ['CLOSED', 'APPROVED', 'SENT', 'IN PROGRESS'],
            headers: [
                { text: '*', value: 'id' },
                { text: 'Name', value: 'nazov' },
                { text: 'Created', value: 'zaciatok' },
                { text: 'Status', value: 'status' },
                { text: '', value: null, sortable: false },
            ],
            page: 1,
            deletionIndex: null,
        };
    },

    mounted() {
        this.page = this.getProjectsCurrentPage;
    },

    methods: {
        ...mapActions(['deleteClientProject']),
        ...mapMutations(['setSelectedProject', 'setIsNewProjectPopup', 'setProjectsCurrentPage']),

        openProject(id) {
            this.setSelectedProject(id);
            this.$router.push({ name: 'project-shortlist', params: { project_id: id } });
        },

        getProjectStatusCSS(state) {
            switch (state) {
                case 'CLOSED':
                    return 'closed';
                case 'IN PROGRESS':
                    return 'progress';
                case 'SENT':
                    return 'sent';
                case 'APPROVED':
                    return 'approved';
                default:
                    return '';
            }
        },

        async deleteItem(item) {
            await this.deleteClientProject(item.id);
            this.deletionIndex = null;
        },
    },

    computed: {
        ...mapGetters(['getClient', 'getSelectedProject', 'getProjectsCurrentPage', 'getProjects']),

        projects() {
            const length = this.getProjects.length;
            this.getProjects.map((project, index) => {
                project.index = length - index;
                return project;
            });

            return this.getProjects.filter((i) => {
                return !this.projectStatus || i.status === this.projectStatus;
            });
        },
    },

    components: {},

    watch: {
        page(val) {
            this.setProjectsCurrentPage(val);
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ClientProjects'] {
    display: flex;
    flex-direction: column;
    height: 0;
    flex-grow: 1;

    .filter {
        display: flex;
        padding: 15px 15px 0;

        .search {
            flex: 0.85;
        }

        .status {
            margin-left: 10px;
            flex: 0.15;
            min-width: 160px;
        }
    }

    .table {
        display: flex;
        flex-direction: column;
        height: 0;
        flex-grow: 1;
        padding: 0 0 0 15px;

        table {
            overflow: hidden !important;
        }

        tr {
            transition: 0.3s;
            position: relative;
            cursor: pointer;
        }

        .selected {
            td {
                background: fade(@base, 10%);

                &.id {
                    border-radius: 30px 0 0 30px;
                }

                &.action {
                    border-radius: 0 30px 30px 0;
                }
            }
        }

        .id {
            width: 65px;
            border-radius: 30px 0 0 30px !important;
        }

        .date {
            width: 180px;
        }

        .status {
            width: 125px;
            padding-right: 0;

            .v-chip {
                &.closed {
                    //background: @primary !important;
                }

                &.progress {
                    color: white;
                    background: @color_green !important;
                }

                &.sent {
                    color: white;
                    background: @color_orange !important;
                }

                &.approved {
                    color: white;
                    background: @color_blue !important;
                }
            }
        }

        .action {
            width: 30px;
            padding-left: 0;
            padding-right: 10px;
            border-radius: 0 30px 30px 0 !important;
        }
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 4px;
        top: 4px;
        height: 40px;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 0 5px 0 20px;
        border-radius: 30px;
        background-color: @primary !important;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            color: white;
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }
    }
}
</style>
